import React from 'react';
import CountDown from '../countDown';
import Typo from '../typo';

const MatchStatusTag = ({ event, utcTime, hideTimer = false }) => {
  const { event_status_id } = event || {};
  const numericStatusId = Number(event_status_id);

  function getMatchStatus(event_status_id) {
    switch (event_status_id) {
      case 1:
        return {
          clsName: 'si-timer',
          lbl: hideTimer ? (
            <Typo transKey={'match_status_upcoming'} component='span'>
              Upcoming
            </Typo>
          ) : (
            <>
              <i className='lms-timer'></i>
              <CountDown utcTime={utcTime} customCls={'si-miniCountDown'} />
            </>
          )
        };
      case 2:
        return {
          clsName: 'si-live',
          lbl: (
            <Typo transKey={'match_status_live'} component='span'>
              Live
            </Typo>
          )
        };
      case 3:
        return {
          clsName: 'si-completed',
          lbl: (
            <Typo transKey='match_status_completed' component='span'>
              Completed
            </Typo>
          )
        };
      case 4:
        return {
          clsName: 'si-completed',
          lbl: (
            <Typo transKey='match_status_completed' component='span'>
              Completed
            </Typo>
          )
        };
      case 5:
        return {
          clsName: 'si-abondoned',
          lbl: (
            <Typo transKey='match_status_abondoned' component='span'>
              Abandoned
            </Typo>
          )
        };
      default:
        return {
          clsName: 'si-upcoming',
          lbl: hideTimer ? (
            <Typo transKey={'match_status_upcoming'} component='span'>
              Upcoming
            </Typo>
          ) : (
            <>
              <i className='lms-timer'></i>
              <CountDown utcTime={utcTime} customCls={'si-miniCountDown'} />
            </>
          )
        };
    }
  }

  const { clsName, lbl } = getMatchStatus(numericStatusId);

  return <div className={`si-matchStatusTag ${clsName}`}>{lbl}</div>;
};

export default MatchStatusTag;
